import { ActiveTimeTracker } from './active-time-tracker';
import { Operation } from './operation';
import { Product } from './product';

export class Nip {
  id?: number;
  batch: string;
  batch_no?: string;
  creator_id: number;
  request_nr: string;
  partner_id: number;
  deadline: any;
  product_id: number;
  packaging_type_id: number;
  required_units: number;
  planned_units: number;
  status_id: number;
  note: string;
  complaint: string;
  created_at?: any;
  updated_at?: string;
  produced_totals_by_operation?: any[];
  deleted_at?: null;
  total_estimated_time: number;
  ready_items: any[];
  priority: number;
  parallel_operations: string;
  partner: any;
  current_op: {
    id: number;
    label: string;
    name: string;
  };
  available_prod_ops?: Operation;
  produced_totals: number;
  current_product_operation_rel_id: number;
  active_time_tracker: ActiveTimeTracker;
  active_break_tracker: any;
  product: Product;
  time_trackers: ActiveTimeTracker[];
  active_time_trackers: ActiveTimeTracker[];
  enable_add_operations: any;
  complete: any;
  total_finished_products: any;
}
